/**
 * La clé repliée d'un concept (C23 SP6, spec § 6.2) : la règle « même terme » du cadrage
 * du 06/10/2026 (décision 3), écrite une fois — accents retirés, apostrophe typographique
 * ramenée à l'apostrophe droite, casse abaissée, blancs de bord rognés, espaces multiples
 * réduites. La clé seule : ni les autres formes, ni les libellés cachés.
 *
 * Ce fichier vit dans `src/utils/` (client, où `foldKey` de `memeTerme.ts` l'appelle) et
 * est COPIÉ octet pour octet dans `api/src/utils/` (la découverte « Face à face avec… »
 * compare les clés avec la même règle). Aucun import : la copie serveur reste autonome
 * (test de dérive `cleRepliee.drift.test.ts`).
 */
export function cleRepliee(s: unknown): string {
  const texte = typeof s === 'string' ? s : '';
  return texte
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/’/g, "'")
    .toLowerCase()
    .trim()
    .replace(/\s+/g, ' ');
}

/** Deux clés disent-elles le même terme ? Une clé vide ne fait face à rien. */
export function memeCleRepliee(a: unknown, b: unknown): boolean {
  const ka = cleRepliee(a);
  return ka !== '' && ka === cleRepliee(b);
}
